/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CampaignAdminDto } from '../models/CampaignAdminDto';
import type { DiscountAppliedTo } from '../models/DiscountAppliedTo';
import type { GetCampaignChannelsAdminResponse } from '../models/GetCampaignChannelsAdminResponse';
import type { GetCampaignExcludeBranchesAdminResponse } from '../models/GetCampaignExcludeBranchesAdminResponse';
import type { GetCampaignGroupsAdminResponse } from '../models/GetCampaignGroupsAdminResponse';
import type { GetCampaignIncludeBranchesAdminResponse } from '../models/GetCampaignIncludeBranchesAdminResponse';
import type { GetCampaignRegionsAdminResponse } from '../models/GetCampaignRegionsAdminResponse';
import type { GetCampaignServicesAdminResponse } from '../models/GetCampaignServicesAdminResponse';
import type { GetCampaignUsersAdminResponse } from '../models/GetCampaignUsersAdminResponse';
import type { Pagination1OfCampaignListedAdminDto } from '../models/Pagination1OfCampaignListedAdminDto';
import type { PostCampaignAdminRequest } from '../models/PostCampaignAdminRequest';
import type { PutCampaignAdminRequest } from '../models/PutCampaignAdminRequest';
import type { PutCampaignChannelsRequestAdmin } from '../models/PutCampaignChannelsRequestAdmin';
import type { PutCampaignExcludeBranchesRequestAdmin } from '../models/PutCampaignExcludeBranchesRequestAdmin';
import type { PutCampaignGroupsRequestAdmin } from '../models/PutCampaignGroupsRequestAdmin';
import type { PutCampaignIncludeBranchesRequestAdmin } from '../models/PutCampaignIncludeBranchesRequestAdmin';
import type { PutCampaignRegionsRequestAdmin } from '../models/PutCampaignRegionsRequestAdmin';
import type { PutCampaignServicesRequestAdmin } from '../models/PutCampaignServicesRequestAdmin';
import type { PutCampaignUsersRequestAdmin } from '../models/PutCampaignUsersRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CampaignsService {
    /**
     * **Required Policy:** `ManageCampaign`
     * @returns CampaignAdminDto Created
     * @throws ApiError
     */
    public static postCampaignAdmin({
        requestBody,
    }: {
        requestBody?: PostCampaignAdminRequest,
    }): CancelablePromise<CampaignAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/campaigns',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCampaigns`
     * @returns Pagination1OfCampaignListedAdminDto OK
     * @throws ApiError
     */
    public static getCampaignsAdmin({
        startDate,
        endDate,
        userId,
        branchId,
        excludedBranchId,
        numberOfSteps,
        groupId,
        channelId,
        serviceId,
        hasStepWithAppliedTo,
        page,
        limit,
    }: {
        startDate?: string,
        endDate?: string,
        userId?: string,
        branchId?: number,
        excludedBranchId?: number,
        numberOfSteps?: number,
        groupId?: number,
        channelId?: number,
        serviceId?: number,
        hasStepWithAppliedTo?: Array<DiscountAppliedTo>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfCampaignListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/campaigns',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'userId': userId,
                'branchId': branchId,
                'excludedBranchId': excludedBranchId,
                'numberOfSteps': numberOfSteps,
                'groupId': groupId,
                'channelId': channelId,
                'serviceId': serviceId,
                'hasStepWithAppliedTo': hasStepWithAppliedTo,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCampaignDetails`
     * @returns CampaignAdminDto OK
     * @throws ApiError
     */
    public static getCampaignAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CampaignAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/campaigns/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCampaign`
     * @returns CampaignAdminDto OK
     * @throws ApiError
     */
    public static putCampaignAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCampaignAdminRequest,
    }): CancelablePromise<CampaignAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/campaigns/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCampaign`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCampaignAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/campaigns/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCampaigns`
     * @returns GetCampaignIncludeBranchesAdminResponse OK
     * @throws ApiError
     */
    public static getCampaignIncludeBranchesAdmin({
        id,
        branchId,
    }: {
        id: number,
        branchId?: number,
    }): CancelablePromise<GetCampaignIncludeBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/campaigns/{id}/include-branches',
            path: {
                'id': id,
            },
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCampaign`
     * @returns any OK
     * @throws ApiError
     */
    public static updateCampaignIncludeBranchesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCampaignIncludeBranchesRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/campaigns/{id}/include-branches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCampaigns`
     * @returns GetCampaignExcludeBranchesAdminResponse OK
     * @throws ApiError
     */
    public static getCampaignExcludedBranchesAdmin({
        id,
        branchId,
    }: {
        id: number,
        branchId?: number,
    }): CancelablePromise<GetCampaignExcludeBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/campaigns/{id}/excluded-branches',
            path: {
                'id': id,
            },
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCampaign`
     * @returns any OK
     * @throws ApiError
     */
    public static updateCampaignExcludedBranchesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCampaignExcludeBranchesRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/campaigns/{id}/excluded-branches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCampaigns`
     * @returns GetCampaignUsersAdminResponse OK
     * @throws ApiError
     */
    public static getCampaignUsersAdmin({
        id,
        userId,
    }: {
        id: number,
        userId?: string,
    }): CancelablePromise<GetCampaignUsersAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/campaigns/{id}/users',
            path: {
                'id': id,
            },
            query: {
                'userId': userId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCampaign`
     * @returns any OK
     * @throws ApiError
     */
    public static updateCampaignUsersAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCampaignUsersRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/campaigns/{id}/users',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCampaigns`
     * @returns GetCampaignGroupsAdminResponse OK
     * @throws ApiError
     */
    public static getCampaignGroupsAdmin({
        id,
        groupId,
    }: {
        id: number,
        groupId?: number,
    }): CancelablePromise<GetCampaignGroupsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/campaigns/{id}/groups',
            path: {
                'id': id,
            },
            query: {
                'groupId': groupId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCampaign`
     * @returns any OK
     * @throws ApiError
     */
    public static updateCampaignGroupsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCampaignGroupsRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/campaigns/{id}/groups',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCampaigns`
     * @returns GetCampaignChannelsAdminResponse OK
     * @throws ApiError
     */
    public static getCampaignChannelsAdmin({
        id,
        channelId,
    }: {
        id: number,
        channelId?: number,
    }): CancelablePromise<GetCampaignChannelsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/campaigns/{id}/channels',
            path: {
                'id': id,
            },
            query: {
                'channelId': channelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCampaign`
     * @returns any OK
     * @throws ApiError
     */
    public static updateCampaignChannelsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCampaignChannelsRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/campaigns/{id}/channels',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCampaigns`
     * @returns GetCampaignRegionsAdminResponse OK
     * @throws ApiError
     */
    public static getCampaignRegionsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCampaignRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/campaigns/{id}/regions',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCampaign`
     * @returns any OK
     * @throws ApiError
     */
    public static updateRegionsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCampaignRegionsRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/campaigns/{id}/regions',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCampaigns`
     * @returns GetCampaignServicesAdminResponse OK
     * @throws ApiError
     */
    public static getCampaignServicesAdmin({
        id,
        serviceId,
    }: {
        id: number,
        serviceId?: number,
    }): CancelablePromise<GetCampaignServicesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/campaigns/{id}/services',
            path: {
                'id': id,
            },
            query: {
                'serviceId': serviceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCampaign`
     * @returns any OK
     * @throws ApiError
     */
    public static updateCampaignServicesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCampaignServicesRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/campaigns/{id}/services',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
